/**
 * Created by justinchasez on 10/5/16.
 */
import {module} from '../app';

module.directive('tooltips', [
    '$compile',
    function ($compile) {
      return {
        restrict: 'A',
        scope: {
          title: '@'
        },
        link: function (scope, element, attrs) {

          function isMobile() {
            return /ios|iphone|ipod|ipad|android/i.test(navigator.userAgent);
          }

          let title = '';
          let maxChars = !isMobile() ? 22 : 20;

          function applyTooltip() {

            let trimmed = false;
            title = scope.title;

            if (title.length > maxChars) {
              title = scope.title.substr(0, maxChars - 3) + '...';
              trimmed = true;
            }

            if (isMobile()) {
              $(element).html("");
              let html = '';

              if (trimmed) {
                title = title.replace('...', '');
                html = '<span on-hold="showTooltips();">' + title + '...</span>';
              } else {
                html = '<span>' + title + '</span>';
              }

              let compiledHtml = $compile(html)(scope);
              $(element).append(compiledHtml);
            } else {
              $(element).text(title);

              $(element).attr('data-title', scope.title).on('mouseover', function () {
                $(element).tooltip('show');
              });
            }
          }

          scope.showTooltips = function () {
            $(element).tooltip('show');

            setTimeout(function () {
              $(element).tooltip('hide');
            }, 3000);
          };

          scope.$watch('title', applyTooltip, true);
          applyTooltip();

        }
      }
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/directives/tooltip.dir.js